import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=d5ae5b34"
import script from "./empty.vue?vue&type=script&lang=js"
export * from "./empty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsOverlay: require('/home/ticketshoplv/public_html/ticketshop.lt/components/elements/Overlay.vue').default,CookiesModal: require('/home/ticketshoplv/public_html/ticketshop.lt/components/cookies/Modal.vue').default})
